import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { axiosReq } from "../../commons/axiosReq";
import BlogArchivePage from "../../components/NewUIComponents/Blog/BlogArchivePage";
import "./PublicPages.css";

const Archive = () => {
  const location = useLocation();
  const slug = location.pathname.split("/")[2] || "all";
  const decoded = decodeURIComponent(slug).replace(/-/g, " ");
  const [data, setData] = useState([]); const [search, setSearch] = useState(""); const [page, setPage] = useState(1); const [count, setCount] = useState(0); const [loading, setLoading] = useState(true); const row = 12;
  useEffect(() => { let active = true; setLoading(true); axiosReq(`Article/GetArticleByCategorySlug?page=${page}&&pageSize=${row}&&search=${encodeURIComponent(search)}&&categorySlug=${encodeURIComponent(slug)}`, "get").then((result) => { if (!active) return; setData(Array.isArray(result?.data) ? result.data : []); setCount(result?.count || 0); setLoading(false); }); return () => { active = false; }; }, [slug, page, search]);
  return <BlogArchivePage title={slug === "all" ? "مجله و راهنماها" : decoded} data={data} loading={loading} search={search} setSearch={setSearch} page={page} setPage={setPage} count={count} row={row} />;
};

export default Archive;
